export default __webpack_public_path__ + "static/media/tp_print_setting.8921003e.svg";